import React, { useEffect, useState } from 'react';
import httpService from '../http.service';

interface MonthAttendanceProps {
	year: number;
	month: number;
	enabled?: boolean;
}

export type MonthAttendanceResponse = {
	monthlyView: {
		profileId: number;
		year: number;
		month: number;
		userId: number;
		customerId: number;
		standardMinutes: number;
		standardDays: number;
		workLogMinutes: number;
		workLogDays: number;
		missDays: number;
	};
	eventsCount: number;
};

export const useMonthAttendance = ({ month, year, enabled = true }: MonthAttendanceProps) => {
	const [attendanceData, setAttendanceData] =
		useState<MonthAttendanceResponse | null>(null);

	const getMonthlyAttendanceData = async () => {
		console.log(`Fetching monthly attendance data for month: ${month}, year: ${year}`);
		try {
			const res = await httpService.api<MonthAttendanceResponse>({
				type: 'getMonthlyAttendanceData',
				params: { year, month },
			});
			console.log('Monthly attendance data: ', res);
			setAttendanceData(res);
		} catch (e) {
			console.log(
				`Error while fetching data from API: getMonthlyAttendanceData api/p/work-log/monthAttendance`,
				e,
			);
		}
	};

	useEffect(() => {
		if (month && year && enabled) {
			getMonthlyAttendanceData();
		}
	}, [month, year, enabled]);

	return attendanceData;
};

// interface OperatorsProps {
// 	unitIds: any;
// 	businessUnitsList: any;
// }
// export const useOperatorsList = ({
// 	businessUnitsList,
// 	unitIds,
// }: OperatorsProps) => {
// 	const operators = useSelector(getOperators);

// 	const dispatch = useDispatch();
// 	const getOperatorList = async () => {
// 		dispatch(
// 			fetchOperatorsList(getSelectedUnits(unitIds, businessUnitsList)),
// 		);
// 	};

// 	useEffect(() => {
// 		if (businessUnitsList.length && unitIds?.length) {
// 			getOperatorList();
// 		}
// 	}, [unitIds, businessUnitsList]);

// 	return operators;
// };
